import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

const Accordion: React.FC<AccordionProps> = (props) => (
  <MuiAccordion {...props} />
);

const AccordionSummary = MuiAccordionSummary;
const AccordionDetails = MuiAccordionDetails;

export default Accordion;

export { AccordionSummary, AccordionDetails };
